// extracted by mini-css-extract-plugin
export default {"walletConnect":"WalletConnect_walletConnect__XqC6C"};